export default "__VITE_ASSET__B37fYL6h__"